import { useMutation } from 'react-query';

import { axios } from '@/lib/axios';
import { MutationConfig } from '@/lib/react-query';

import { UseAvailabilityOptions, Slot } from '../types';
import { useNotificationStore } from '@/stores/notifications';
import { RecurringAppointment } from './getRecurringSlots';

export const getAvailabilities = ({
  serviceId,
  duration,
  date,
  tz,
  userId,
  forRecurring,
}: UseAvailabilityOptions = {}): Promise<RecurringAppointment[]> => {
  const reqParam: UseAvailabilityOptions = { duration, date, forRecurring };
  if (userId) {
    reqParam.userId = userId;
  }
  if (serviceId) {
    reqParam.serviceId = serviceId;
  }
  if (tz) {
    reqParam.tz = tz;
  }
  return axios.get(`/business/calendar/availability`, {
    params: reqParam,
  });
};

type UseUpdateBusinessOptions = {
  config?: MutationConfig<typeof getAvailabilities>;
};

export const useGetAvailabilitiesForRecurring = ({ config }: UseUpdateBusinessOptions = {}) => {
  const { addNotification } = useNotificationStore();
  return useMutation({
    ...config,
    mutationFn: getAvailabilities,
  });
};
